import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { NgxMatNativeDateAdapter } from '@ngxmc/datetime-picker';

@Injectable()
export class CustomDatetimeAdapter extends NgxMatNativeDateAdapter {
    override parse(value: string): Date | null {
        try {
            let date = new Date(value);
            return new Date(new DatePipe(this.locale).transform(date, 'short'));
        } catch (error) {
            console.log('format erreur');
            return null;
        }
    }

    override format(date: Date, display: string): string {
        if (display === 'customInput') {
            return new DatePipe(this.locale).transform(date, 'short');
        } else {
            return new DatePipe(this.locale).transform(date, 'MMM yyyy');
        }
    }
}
